import { Component } from '@angular/core';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ExpenseManager-UI';


  // constructor(private route: ActivatedRoute){
  //   // console.log('route+',route)
  //   this.route.queryParamMap.subscribe(p => {

  //     const keys = p.keys;
  //     // console.log('keysParam',keys);
  //     keys.forEach(key => {
  //       // console.log(key);
  //       console.log(key + " from query param ==== "+ p.get(key));
  //     })
  //   })
    
  //   this.route?.data.subscribe(p => {
  //     // console.log(p)
  //     const keys = p['keys'];
  //     // console.log('key1Data',keys);
  //     keys.forEach((key: string) => {
  //       // console.log('key1',key);
        
  //       // console.log(key + " from data ==== "+ p['get'](key));
  //     })
  //   })
  // }
}
